import type { IconProps } from '@/shared/ui/icons/types';

export const FlagKzIcon = (props: IconProps) => (
  <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="20" fill="#00afca" />
    <g fill="#fec50c">
      <path d="M2.3 1.2l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 3.1l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 5.0l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 6.9l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 8.8l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 10.7l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 12.6l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 14.5l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 16.4l0.9 0.8-0.9 0.8-0.9-0.8ZM2.3 18.3l0.9 0.8-0.9 0.8-0.9-0.8Z" />
      <rect x="3.6" y="1" width="0.35" height="18" />
      <rect x="0.65" y="1" width="0.35" height="18" />
    </g>
    <circle
      cx="15.5"
      cy="8"
      r="3.7"
      fill="none"
      stroke="#fec50c"
      strokeWidth="1.3"
      strokeDasharray="0.55 0.62"
    />
    <circle cx="15.5" cy="8" r="2.5" fill="#fec50c" />
    <path
      d="M10.2 13.6c1.6-1.5 3.4-1.4 5.3-0.3 1.9-1.1 3.7-1.2 5.3 0.3-1.8-0.4-3.4 0.1-4.6 1.4l-0.7 0.9-0.7-0.9c-1.2-1.3-2.8-1.8-4.6-1.4Z"
      fill="#fec50c"
    />
  </svg>
);
